import { create } from 'zustand';

const initialState = {
  enabledCategories: {},
};

const useCookieStore = create((set) => ({
  ...initialState,
  actions: {
    setEnabledCategory: (categoryName, enabled) => set((state) => ({
      enabledCategories: {
        ...state.enabledCategories,
        [categoryName]: enabled,
      },
    })),
    toggleEnabledCategory: (categoryName) => set((state) => ({
      enabledCategories: {
        ...state.enabledCategories,
        [categoryName]: !state.enabledCategories[categoryName],
      },
    })),
    setEnabledCategories: (categories) => set(() => ({
      enabledCategories: { ...categories },
    })),
    initializeNecessaryCategory: () => set((state) => ({
      enabledCategories: {
        ...state.enabledCategories,
        NECESSARY: true,
      },
    })),
    // Initialize categories from API data with existing consent
    initializeCategoriesFromData: (profileData, existingConsentCategories = {}) => set((state) => {
      if (!profileData?.data?.cookies) return state;

      const newEnabledCategories = { ...state.enabledCategories };

      profileData.data.cookies.forEach((category) => {
        const categoryName = category.category;

        // If we have existing consent, use that; otherwise default behavior
        if (Object.keys(existingConsentCategories).length > 0) {
          // Use existing consent preferences
          newEnabledCategories[categoryName] = existingConsentCategories[categoryName] || false;
        } else if (categoryName === 'NECESSARY') {
          // Default behavior: only NECESSARY is enabled
          newEnabledCategories[categoryName] = true;
        }
      });

      return { enabledCategories: newEnabledCategories };
    }),
    resetCookiePreferences: () => set(() => ({
      enabledCategories: {},
    })),
  },
}));

export const useCookieActions = () => useCookieStore.getState().actions;
export const useEnabledCategories = () => useCookieStore((state) => state.enabledCategories);

export default useCookieStore;
